import React from "react";
import { stepFiveData } from "./stepData";
import { Typography } from "@mui/material";

const StepFive = () => {
  return (
    <>
      <div id="step_two_data">
        <div className=" mt-3 d-flex flex-column gap-3">
          <Typography
            sx={{
              fontSize: "23.8532px",
              lineHeight: "24px",
              textAlign: "start",
              fontFamily: "'Archivo', sans-serif",
              color: "#1F1F1F",
              fontWeight: 700,
            }}
          >
            {stepFiveData[0].heading}
          </Typography>

          <Typography
            sx={{
              fontSize: 16,
              lineHeight: "24px",
              letterSpacing: "0.08px",
              fontWeight: 500,
              fontFamily: "'Archivo',sans-serif",
            }}
          >
            The <strong>Annual Percentage Rate (APR)</strong> is a more
            comprehensive metric than the interest rate alone, as it includes
            additional charges like processing fees. Comparing APR across
            different loans allows you to evaluate which loan is more
            cost-effective in the long run.
          </Typography>
        </div>
      </div>
    </>
  );
};

export default StepFive;
